<template>
    <div>
        <ul id="excellentList">
            <li  v-for="value in excellentListData" :key="value">
                <div class="cover-pic">
                    <a :href="value.url">
                        <img :src="value.headsrc" alt="">
                        <span :class="value.largevClass"></span>
                    </a>
                </div>
                <div class="info">
                    <h3><a :href="value.url">{{value.medianame}}</a></h3>
                    <p :id="value.userid"><span><span>粉丝</span><span class="fansPv">{{value.fans}}</span></span><i></i>&nbsp;&nbsp;<span><span>阅读量</span><span class="readPv">{{value.read_pv}}</span></span></p>
                </div>
            </li>
        </ul>
        <Loading v-if="loadingShow"></Loading>
        <NoMore v-if="noData"></NoMore>
    </div>
</template>

<script>
    import {getUserRecommends, getReadPvRecommends} from './../../axios/api.js'
    import Loading from './../loading.vue'
    import NoMore from './../loadingNoMore.vue'
    let pgno;
    export default {
        data() {
            return {
                excellentListData: [],
                loadingShow: false,
                noData: false,
                loadSwitch: true,
                pgno: 1,
            }
        },
        activated(){
            this.pgno = 1;
        },
        mounted(){
            this.getUserRecommends(1);
            // 注册scroll事件并监听 
            // let that = this;
            pgno = this.pgno;
            window.addEventListener('scroll', this.scorllLoadData);
        },
        beforeDestroy (){
            window.removeEventListener('scroll', this.scorllLoadData);
        },
        components: {
            Loading,
            NoMore
        },
        methods: {
            scorllLoadData (){
                let excellentSelected = document.getElementsByClassName('vue-tab')[2].getAttribute('aria-selected');
                // console.log(document.documentElement.clientHeight+'-----------'+window.innerHeight); // 可视区域高度  
                // console.log(document.body.scrollTop); // 滚动高度  
                // console.log(document.documentElement.scrollTop); // 滚动高度  
                // console.log(document.body.offsetHeight); // 文档高度  
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                let innerHeight = window.innerHeight;
                let offsetHeight = document.body.offsetHeight;
                // 判断是否滚动到底部  
                if(scrollTop + innerHeight >= offsetHeight) { 
                    // 如果开关打开则加载数据  
                    if(this.loadSwitch && !this.noData && excellentSelected == 'true'){
                        pgno++;
                        this.getUserRecommends(pgno);
                    }
                }
            },
            getUserRecommends (pgno){ // 获取近期发布文章数据
                this.loadSwitch = false;
                this.loadingShow = true;
                let params = {
                    pgnum: pgno,
                    pgsize: 10,
                }
                let that = this;
                getUserRecommends(params).then( result => {
                    if(result.stat == 1){
                        if(!result.data.length){
                            that.loadingShow = false;
                            that.noData = true;
                            return false;
                        }else{
                            let userRecommendsData = result.data;
                            let urlidArr = [];
                            for(let i=0;i<userRecommendsData.length;i++){
                                urlidArr.push(userRecommendsData[i].userid);
                            }
                            urlidArr=urlidArr.join(',');
                            let readPvParams={
                                uselist: urlidArr
                            };
                            getReadPvRecommends(readPvParams).then( res => {
                                if(res.stat == 1){
                                    let readPvData = res.data;
                                    // console.log(res)
                                    for(let i = 0; i < userRecommendsData.length; i++){
                                        for(let j = 0; j < readPvData.length; j++){
                                            if(userRecommendsData[i].userid == readPvData[j].userid){
                                                userRecommendsData[i].read_pv = readPvData[j].read_pv;
                                            }
                                        }
                                        userRecommendsData[i].url = 'http://mini.eastday.com/toutiaoh5/page_dfh.html?dfhid='+userRecommendsData[i].userid;
                                        userRecommendsData[i].largevClass = 'originallevel bigV'+userRecommendsData[i].largev;
                                        that.excellentListData.push(userRecommendsData[i]);
                                    }
                                    that.loadSwitch = true;
                                    if(userRecommendsData.length < 10){
                                        that.noData = true;
                                    }else{
                                        that.noData = false;
                                    }
                                }
                            })
                            that.loadingShow = false;
                        }
                    }
                })
            },
        }
    }
</script>
<style scoped>    
    #excellentList li {
        width: 100%;
        height: 2.4rem;
        background: #fff;
        border-bottom: 1px solid #e1e1e1;
        padding: 0.3rem;
    }

    #excellentList li .info h3 a {
        display: inline-block;
        color: #333333;
        height: 100%;
        overflow: hidden;
    }

    #excellentList li .info p {
        color: #999999;
        font-size: 0.24rem;
        margin: 0.1rem 0;
    }

    #excellentList li .info p:last-child {
        color: #999999;
        font-size: 0.28rem;
        margin-bottom: 0;
        margin-top: 0.15rem;
    }
    #excellentList li .info p:last-child > span {
        display: inline-block;
        overflow: hidden;
    }
    #excellentList li .info p:last-child > span span{
        float: left;
        margin-right: 0.1rem;
        font-size: 0.24rem;
    }
    #excellentList li .info p .read-icon{
        display: inline-block;
        width: 0.38rem;
        height: 0.38rem;
        background: url('./../../assets/img/read-icon.png') no-repeat center center;
        background-size: 0.38rem 0.38rem;
        position: relative;
        top: -0.028rem;
    }

    #excellentList li .info p .comment-icon{
        display: inline-block;
        width: 0.38rem;
        height: 0.38rem;
        background: url('./../../assets/img/comment-icon.png') no-repeat center center;
        background-size: 0.38rem 0.38rem;
        position: relative;
        top: -0.02rem;
    }


    #excellentList li .cover-pic img {
        width: 100%;
    }

    #excellentList li:last-child {
        margin-bottom: 0
    }
    /* 优质用户 */
    #excellentList li{
        height: auto;
        overflow: hidden;
    }
    #excellentList .cover-pic {
        float: left;
        width: 1.4rem;
        height: 1.4rem;
        /* border-radius: 50%; */
        /* overflow: hidden; */
        position: relative;
    }
    #excellentList .cover-pic img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
    #excellentList .info {
        float: right;
        width: 5rem;
        padding-left: 0.15rem;
    }
    #excellentList .info h3{
        height: 0.7rem;
        font-size: 0.34rem;
        font-weight: normal;
        line-height: 0.8rem;
        margin-bottom: 0.15rem;
    }
    #excellentList .info p:last-child > span{
        margin-right: 0.5rem;
    }
    #excellentList .info p:last-child span.fansPv{
        position: relative;
        top: 0.04rem;
    }
    #excellentList .info p:last-child span.readPv{
        position: relative;
        top: 0.04rem;
    }
    /* 大V、原创标签图标 */
    #excellentList .cover-pic span{
        display: inline-block;
        position: absolute;
        bottom: -0.04rem;
        right: -0.04rem;
        width: 0.5rem;
        height: 0.5rem;
        z-index: 99;
    }
    #excellentList .cover-pic span.originallevel{ background: url('./../../assets/img/original.png') no-repeat center center; background-size: 0.5rem 0.5rem;}
    #excellentList .cover-pic span.bigV1{ background: url('./../../assets/img/bigV1.png') no-repeat center center; background-size: 0.5rem 0.5rem;}
    #excellentList .cover-pic span.bigV2{ background: url('./../../assets/img/bigV2.png') no-repeat center center; background-size: 0.5rem 0.5rem;}
    #excellentList .cover-pic span.bigV3{ background: url('./../../assets/img/bigV3.png') no-repeat center center; background-size: 0.5rem 0.5rem;}
    #excellentList .cover-pic span.bigV4{ background: url('./../../assets/img/bigV4.png') no-repeat center center; background-size: 0.5rem 0.5rem;}
    #excellentList .cover-pic span.bigV5{ background: url('./../../assets/img/bigV5.png') no-repeat center center; background-size: 0.5rem 0.5rem;}
</style>




// WEBPACK FOOTER //
// src/components/homepage/excellentUser.vue